import OSS from "ali-oss"

const headers = {
    // 指定Object的存储类型。
}

// 开始分片上传。
export async function multipartUpload(raw, onProgress, config) {

    let client = new OSS({
        endpoint: config.endpoint,
        accessKeyId: config.accessKeyId,
        accessKeySecret: config.accessKeySecret,
        secure: true,
        cname: config.enableCname,
        stsToken: config.securityToken,
        bucket: config.bucket
    });

    let checkpoint = null;

    for (let i = 0; i < 10; i++) {
        try {
            const result = await client.multipartUpload(config.key, raw, {
                checkpoint,
                parallel:10,
                partSize: 5 * 1024 * 1024,
                headers,
                progress: (p, _checkpoint) => {
                    checkpoint = _checkpoint;
                    onProgress ? onProgress(p) : null;
                },
            });
            console.log(result);
            return result
        } catch (e) {
            // 捕获超时异常。
            if (e.code === 'ConnectionTimeoutError') {
                console.log('TimeoutError', e);
            } else {
                console.log(e);
                throw e
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/fs/oss/index.js